export default {
  title: {
    text: "国内正极材料市场企业占比",
    left: "center",
    top: 20,
  },

  tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b} : ({d}%)",
  },

  visualMap: {
    show: false,
    min: 100,
    max: 1000,
    inRange: {
      colorLightness: [0, 0.8],
    },
  },
  series: [
    {
      name: "材料供应商",
      type: "pie",
      radius: "55%",
      center: ["50%", "60%"],
      data: [
        { value: 934, name: "厦门钨业" },
        { value: 767, name: "湖南杉杉" },
        { value: 581, name: "长远锂科" },
        { value: 574, name: "当升科技" },
        { value: 563, name: "天津巴莫" },
        { value: 509, name: "容百锂电" },
        { value: 509, name: "德方纳米" },
        { value: 472, name: "振华新能源" },
        { value: 425, name: "桑顿新能源" },
      ].sort(function (a, b) {
        return a.value - b.value;
      }),
      roseType: "radius",
      label: {
        color: "#43c8f7",
      },
      labelLine: {
        lineStyle: {
          color: "#43c8f7",
        },
        smooth: 0.2,
        length: 10,
        length2: 20,
      },
      itemStyle: {
        color: "#43c8f7",
        shadowBlur: 200,
        shadowColor: "rgba(0, 0, 0, 0.5)",
      },

      animationType: "scale",
      animationEasing: "elasticOut",
      animationDelay: function (idx) {
        return Math.random() * 200;
      },
    },
  ],
};
